import React from 'react'

export default function CancelImg() {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-square-x " width="30" height="30" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#878686" fill="none" strokeLinecap="round" strokeLinejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" />
  <path d="M9 9l6 6m0 -6l-6 6" />
</svg>
    </div>
  )
}
